(function() {
  function initNwVideoRows() {
    var rows = document.querySelectorAll('[data-nw-video-row]');
    rows.forEach(function(row) {
      if (row.dataset.nwVideoInit === 'true') return;
      row.dataset.nwVideoInit = 'true';

      var wraps = row.querySelectorAll('.nw-video-wrap');
      wraps.forEach(function(wrap) {
        var video = wrap.querySelector('.nw-video-element');
        var btn = wrap.querySelector('.nw-video-play-btn');
        if (!video || !btn) return;

        function pauseAllInRow(exceptVideo) {
          row.querySelectorAll('.nw-video-wrap').forEach(function(w) {
            var v = w.querySelector('.nw-video-element');
            if (v && v !== exceptVideo && !v.paused) {
              v.pause();
              w.classList.remove('is-playing');
            }
          });
        }

        function toggleThis() {
          if (video.paused) {
            pauseAllInRow();
            video.play();
            wrap.classList.add('is-playing');
          } else {
            video.pause();
            wrap.classList.remove('is-playing');
          }
        }

        wrap.addEventListener('click', function(e) {
          e.preventDefault();
          toggleThis();
        });

        video.addEventListener('play', function() {
          pauseAllInRow(video);
          wrap.classList.add('is-playing');
        });
        video.addEventListener('pause', function() {
          wrap.classList.remove('is-playing');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNwVideoRows);
  } else {
    initNwVideoRows();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-nw-video-row]')) {
      initNwVideoRows();
    }
  });
})();
